module.exports = __webpack_public_path__ + "static/img/sam-cover-img-09.e2aac354.jpg";